import classnames from "classnames";
import React, { type FC } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../../images/aic_logo_2026.svg";
import styles from "../../../styles.module.scss";

interface PortalLogoProps extends WithTranslation {
  isNest?: boolean;
}

const PortalLogo: FC<PortalLogoProps> = ({ t, isNest }) => {
  const to = isNest ? "/inbound-central/nest" : "/inbound-central";

  return (
    <div>
      <Link to={to} title={t("aic_app_page_title_text")}>
        <img
          className={classnames(styles.w_100)}
          src={logo}
          alt={t("aic_app_page_title_text")}
        />
      </Link>
    </div>
  );
};

export default withTranslation()(PortalLogo);
